import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  useToggle
} from '@lucidhq/lucidium';

import {
  CampaignPixel,
  CampaignPixelVariables,
  useEditCampaignPixelGroup
} from '~/components/Shared/hooks/useMutateCampaignPixelGroup';

import { useCampaignManager } from '../../CampaignManagerProvider';
import { UniversalTagForm } from './UniversalTagForm';

type UpdateUniversalTagProps = {
  campaignId: string;
  pixel: CampaignPixel;
  id: string;
  onUpdate: () => void;
  children: ({ onToggle }: { onToggle: () => void }) => React.ReactNode;
};

export const UpdateUniversalTag = ({
  children,
  pixel,
  id,
  campaignId,
  onUpdate
}: UpdateUniversalTagProps) => {
  const [isOpen, handleToggle] = useToggle(false);
  const { mutate, isLoading } = useEditCampaignPixelGroup(campaignId, id);
  const { onMutateError } = useCampaignManager();

  const handleSubmit = (params: CampaignPixelVariables) => {
    mutate(
      {
        campaign_pixels: [{ id: pixel.pixel_id, ...params }]
      },
      {
        onSuccess: () => {
          onUpdate();
          handleToggle();
        },
        ...onMutateError
      }
    );
  };

  const initialValues = {
    ad_server_id: `${pixel.ad_server_id}`,
    ...pixel.query_params
  };

  return (
    <>
      {children({ onToggle: handleToggle })}
      <Dialog isOpen={isOpen} onClose={handleToggle} lss={{ width: '43rem' }}>
        <DialogHeader palette="disabled" onClose={handleToggle}>
          {pixel.ad_server_name}
        </DialogHeader>
        <DialogContent>
          <UniversalTagForm
            isLoading={isLoading}
            onSubmit={handleSubmit}
            onCancel={handleToggle}
            initialValues={initialValues}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
